import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState, useRef } from 'react';
import { RiMore2Line } from 'react-icons/ri';

import styles from './MoreMenu.module.scss';

const cx = classNames.bind(styles);

const MoreMenu = ({ data: menus }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef();
  const panelRef = useRef();

  // 부모 요소 중 transform 속성을 가진 요소 찾기
  const findTransformParent = () => {
    let element = containerRef.current?.parentElement;

    while (element) {
      const style = window.getComputedStyle(element);
      if (style.transform && style.transform !== 'none') {
        return element;
      }
      element = element.parentElement;
    }

    return null;
  };

  useUpdateEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', unfocusPanel);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', unfocusPanel);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const unfocusPanel = (e) => {
    if (containerRef.current.contains(e.target)) return;
    if (panelRef.current.contains(e.target)) return;

    setIsOpen(false);
  };

  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      setIsOpen(false);
    }
  };

  const togglePanel = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);

    const rect = e.currentTarget.getBoundingClientRect();
    let top = rect.y + 28;
    let left = rect.x + 4;

    // transform 부모가 있으면 부모 좌표만큼 보정
    const transformParent = findTransformParent();
    if (transformParent) {
      const parentRect = transformParent.getBoundingClientRect();
      top -= parentRect.y;
      left -= parentRect.x;
    }

    panelRef.current.style.top = `${top}px`;
    panelRef.current.style.left = `${left}px`;
  };

  return (
    <div ref={containerRef} className={cx('container')} onClick={togglePanel}>
      <RiMore2Line size={16} color="white" />
      <div ref={panelRef} className={cx(['panel', { open: isOpen }])}>
        <div className={cx('arrow')} />
        {menus.map((menu, index) => (
          <div key={index} className={cx('item')} onClick={menu.callback}>
            {menu.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoreMenu;
